import React from "react";
import { Button, Table } from "react-bootstrap";
import { Edit, Trash } from "react-feather";
import { formatDate } from "../config/function";

const ContractorPaymentList = ({
  paymentData,
  handleEdit,
  handleDelete,
  contractors,
  fromDate,
  toDate,
  contractorId,
  handleFilterChange,
  handleFilter,
  handleClearFilter,
}) => {
  return (
    <>
      {/* Filters */}
      <div className="row mb-3">

        {/* Contractor */}
        <div className="col-md-4">
          <label className="form-label">
            Contractor
          </label>

          <select
            className="form-select"
            name="contractor_id"
            value={contractorId}
            onChange={handleFilterChange}
          >
            <option value="">
              All Contractors
            </option>

            {contractors.map((contractor) => (
              <option
                key={contractor.id}
                value={contractor.id}
              >
                {contractor.name}
              </option>
            ))}
          </select>
        </div>


        {/* From Date */}
        <div className="col-md-3">
          <label className="form-label">
            From Date
          </label>

          <input
            type="date"
            className="form-control"
            name="from_date"
            value={fromDate}
            onChange={handleFilterChange}
          />
        </div>


        {/* To Date */}
        <div className="col-md-3">
          <label className="form-label">
            To Date
          </label>

          <input
            type="date"
            className="form-control"
            name="to_date"
            value={toDate}
            onChange={handleFilterChange}
          />
        </div>


        {/* Buttons */}
        <div className="col-md-2 d-flex align-items-end gap-2">

          <Button
            variant="primary"
            onClick={handleFilter}
          >
            Filter
          </Button>

          <Button
            variant="secondary"
            onClick={handleClearFilter}
          >
            Clear
          </Button>

        </div>

      </div>


      {/* Payment Table */}
      <Table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Date</th>
            <th>Contractor</th>
            <th>Contact</th>
            <th>Amount</th>
            <th>Remarks</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>

          {paymentData.length > 0 ? (

            paymentData.map((data, index) => (

              <tr key={data.id || index}>

                <td>
                  {index + 1}
                </td>

                <td>
                  {formatDate(data.date)}
                </td>

                <td style={{ textTransform: "capitalize" }}>
                  {data.contractor_name}
                </td>

                <td>
                  {data.contact_number}
                </td>

                <td>
                  {Number(data.amount).toFixed(2)}
                </td>

                <td>
                  {data.remarks}
                </td>

                <td>

                  <div className="d-flex gap-2">

                    <Button
                      variant="warning"
                      size="sm"
                      onClick={() => handleEdit(data)}
                    >
                      <Edit size={14} />
                    </Button>

                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDelete(data.id)}
                    >
                      <Trash size={14} />
                    </Button>

                  </div>

                </td>

              </tr>

            ))

          ) : (

            <tr>
              <td
                colSpan="7"
                className="text-center"
              >
                No payments found
              </td>
            </tr>

          )}

        </tbody>
      </Table>
    </>
  );
};

export default ContractorPaymentList;